import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Automation } from "../_types/automation";
import { AutomationEvent } from "../_types/automation-event";
@Injectable({
    providedIn: 'root',
})

export class AutomationsEventsService extends Service<AutomationEvent> {
  public override type = 'automationsEvents';
  public override url = 'common/automationEvents';

  getDropdownOptions(id: string, fieldName: string) {
    let url = this.getAPIUrl()+"/"+id+"/dropdownSqlOptions/"+fieldName;
    return this.http.post<any>(url, null);
  }  
}
